import { AppSuccess } from './AppSuccess';
import { User_Base } from './User';
import { MapDataFile_Base } from './MapDataFile';
import { PaginationQuery, PaginationResult } from './AppPagination';
import { Audit } from './Audit';
import { UploadTask_Base } from './UploadTask';
import { StrapiModel_Base } from './StrapiModel';

export enum MapData_PublishStatus {
  PUBLIC = 'PUBLIC', // for everyone
  AUTHENTICATED = 'AUTHENTICATED', // authenticated user only
  PRIVATE = 'PRIVATE', // owner only
}

export enum MapData_ProcessStatus {
  PENDING = 'PENDING', // when user upload files
  SUBMITED = 'SUBMITED', // when user click run
  SUCCESS = 'SUCCESS', // the system will run and update this
  FAILED = 'FAILED', // the system will run and update this
  PROCESSING = 'PROCESSING', // the system will run and update this

  WAITING_USER_INPUT = 'WAITING_USER_INPUT',
}

export const MapData_ModelUtil = {
  getStatusColor: (status: MapData_ProcessStatus) => {
    switch (status) {
      case MapData_ProcessStatus.PENDING:
      case MapData_ProcessStatus.SUBMITED:
      case MapData_ProcessStatus.WAITING_USER_INPUT:
        return 'gold';
      case MapData_ProcessStatus.PROCESSING:
        return 'blue';
      case MapData_ProcessStatus.SUCCESS:
        return 'green';
      case MapData_ProcessStatus.FAILED:
        return 'red';
      default:
        return 'default';
    }
  },
  getTextStatus: (status: MapData_ProcessStatus) => {
    switch (status) {
      case MapData_ProcessStatus.PENDING:
        return 'Chờ xử lý';
      case MapData_ProcessStatus.SUBMITED:
        return 'Đã gửi';
      case MapData_ProcessStatus.PROCESSING:
        return 'Đang xử lý';
      case MapData_ProcessStatus.SUCCESS:
        return 'Thành công';
      case MapData_ProcessStatus.FAILED:
        return 'Thất bại';
      case MapData_ProcessStatus.WAITING_USER_INPUT:
        return 'Chờ nhập liệu';
      default:
        return 'Không xác định';
    }
  },
};

export enum MapData_Workflow {
  GIS_BASIC = 'gis_basic',
  DJI_LOG = 'dji_log',
}
export enum MapData_Encoding {
  UNICODE = 'unicode',
}

export * from './SpatialMetadata';
import { SpatialDatasetMetadata } from './SpatialMetadata';

export type MapData_Metadata = SpatialDatasetMetadata & {
  driverShortName?: string;
  isVector?: boolean;
  isRaster?: boolean;
  gdalInfo?: string;
  ogrInfo?: string;
};

export type MapData_InputMetadata = {
  srs?: string;
  encoding?: MapData_Encoding;
  workflow?: MapData_Workflow;
}

/**
 * MapData
 *
 * MapData là 1 map layer được tạo ra từ các file được upload lên
 */
export type MapData_Base = StrapiModel_Base & Audit & {
  name: string;
  description: string;
  publish_status: MapData_PublishStatus;
  metadata: string; // json
  cost: number;
  category: string;
  owner?: User_Base;
  map_data_files?: Array<MapDataFile_Base>;
  gid_1?: string;
  gid_2?: string;
  gid_3?: string;

  processInputFiles?: any;
  processInputMetadata?: string; // json: MapData_InputMetadata
  processStatus?: MapData_ProcessStatus; // MapData_ProcessStatus
  processMessage?: string;
  upload_task?: UploadTask_Base;
  priority?: number; // Processing priority - lower values processed first (default: 1000)
};

export type MapData_GetList_RequestQuery = PaginationQuery & {
  category?: string;
  keyword?: string;
  gid_1?: string;
  gid_2?: string;
  gid_3?: string;
  upload_task_id?: number; // filter by upload task id
  phone_number?: string; // filter by owner phone number
};

export type MapData_GetList_Response = PaginationResult<MapData_Base>;

export type MapData_Create_Request = {
  name: string;
  description: string;
  category?: string;
  publish_status?: MapData_PublishStatus;
  metadata?: string;
  cost?: number;
  gid_1?: string;
  gid_2?: string;
  gid_3?: string;

  processInputFiles: any;
  processInputMetadata: string; // json

  projectId?: number;
};

export type MapData_Create_Response = AppSuccess<MapData_Base>;

export type MapData_Update_Request = {
  name?: string;
  description?: string;
  category?: string;
  publish_status?: MapData_PublishStatus;
  metadata?: string;
  cost?: number;
  gid_1?: string;
  gid_2?: string;
  gid_3?: string;

  processInputMetadata?: string; // json
  processStatus?: string; // SUBMITED
};
export type MapData_Update_Response = AppSuccess<MapData_Base>;

export type MapData_Delete_Response = AppSuccess<MapData_Base>;

export type MapData_InputFile = {
  name: string;
  size: number;
  mtime: string; // ISO date string
  mode: number; // e.g., 0o755
  isDirectory: boolean;
};
